import { Copy } from 'lucide-react';
import type { License } from '../../types/domain';
import { c } from '../../styles/theme';

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="lyx-reseller-summary-row">
      <span>{label}</span>
      <b>{value}</b>
    </div>
  );
}

export default function ResellerLicenseSummary({
  license,
  onCopy,
}: {
  license: License;
  onCopy: () => void;
}) {
  const status = license.status.charAt(0).toUpperCase() + license.status.slice(1);
  return (
    <section aria-labelledby="reseller-license-summary-title" style={{ marginTop: 22 }}>
      <p
        id="reseller-license-summary-title"
        style={{ fontSize: 12, color: c.text2, margin: '0 0 8px' }}
      >
        License summary
      </p>
      <div className="lyx-reseller-summary">
        <Row label="License holder" value={license.customerName} />
        <Row label="Plan" value={license.product} />
        <Row label="License status" value={status} />
        <Row label="License type" value="Reseller License" />
        <Row label="First issued" value={license.issuedDate} />
        <Row label="Agreement version" value={`v${license.version}`} />
        <div className="lyx-reseller-summary-row is-last">
          <span>Verification URL</span>
          <div>
            <b>{license.verifyUrl.replace(/^https?:\/\//, '')}</b>
            <button type="button" onClick={onCopy} aria-label="Copy verification link">
              <Copy size={13} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
